export default "/images/logo-6.png?cab6aa4e41b4e904663ca4192528447f";